import type { CommandListResponse } from '@/types'

const NODE1 = 'aaaaaaaa-0001-0001-0001-000000000001'
const NODE2 = 'aaaaaaaa-0002-0002-0002-000000000002'
const NODE3 = 'aaaaaaaa-0003-0003-0003-000000000003'

const ALL_COMMANDS: CommandListResponse['items'] = [
  {
    id: 'cccccccc-0001-0001-0001-000000000001',
    node_id: NODE1,
    type: 'recording.start',
    status: 'running',
    camera_key: 'cam0',
    requested_by: 'admin',
    reason: 'model debugging — false alarm on cam-01',
    idempotency_key: 'idem-0001-0001-0001-0001',
    expires_at: new Date(Date.now() + 1800000).toISOString(),
    created_at: new Date(Date.now() - 620000).toISOString(),
    dispatched_at: new Date(Date.now() - 610000).toISOString(),
    completed_at: null,
    log_tail: '[2026-05-19 09:00:05] Recording started: /data/manual/cam0/\n[2026-05-19 09:01:00] Chunk 1 written: 20260519_090000.mp4\n[2026-05-19 09:10:00] Disk free: 128GB - OK',
  },
  {
    id: 'cccccccc-0002-0002-0002-000000000002',
    node_id: NODE2,
    type: 'upload.start',
    status: 'failed',
    camera_key: null,
    requested_by: 'operator',
    reason: 'weekly NAS sync',
    idempotency_key: 'idem-0002-0002-0002-0002',
    expires_at: null,
    created_at: new Date(Date.now() - 7200000).toISOString(),
    dispatched_at: new Date(Date.now() - 7190000).toISOString(),
    completed_at: new Date(Date.now() - 7000000).toISOString(),
    log_tail: '[2026-05-19 07:03:20] Failed to sync directory: connection reset by peer',
  },
  {
    id: 'cccccccc-0003-0003-0003-000000000003',
    node_id: NODE1,
    type: 'recording.stop',
    status: 'queued',
    camera_key: 'cam0',
    requested_by: 'admin',
    reason: null,
    idempotency_key: 'idem-0003-0003-0003-0003',
    expires_at: new Date(Date.now() + 300000).toISOString(),
    created_at: new Date(Date.now() - 30000).toISOString(),
    dispatched_at: null,
    completed_at: null,
    log_tail: null,
  },
  {
    id: 'cccccccc-0004-0004-0004-000000000004',
    node_id: NODE3,
    type: 'upload.start',
    status: 'succeeded',
    camera_key: null,
    requested_by: 'operator',
    reason: 'ad-hoc upload request',
    idempotency_key: 'idem-0004-0004-0004-0004',
    expires_at: null,
    created_at: new Date(Date.now() - 1800000).toISOString(),
    dispatched_at: new Date(Date.now() - 1790000).toISOString(),
    completed_at: new Date(Date.now() - 900000).toISOString(),
    log_tail: '[2026-05-19 09:15:00] Finished transfer in 900.2s — 1 file OK',
  },
  {
    id: 'cccccccc-0005-0005-0005-000000000005',
    node_id: NODE1,
    type: 'recording.start',
    status: 'succeeded',
    camera_key: 'cam1',
    requested_by: 'admin',
    reason: 'data collection for retraining',
    idempotency_key: 'idem-0005-0005-0005-0005',
    expires_at: null,
    created_at: new Date(Date.now() - 86400000).toISOString(),
    dispatched_at: new Date(Date.now() - 86390000).toISOString(),
    completed_at: new Date(Date.now() - 82800000).toISOString(),
    log_tail: null,
  },
]

export function mockCommands(nodeId?: string): CommandListResponse {
  const items = nodeId
    ? ALL_COMMANDS.filter((c) => c.node_id === nodeId)
    : ALL_COMMANDS
  return { items, total: items.length }
}
